export function createConsentServices({ consent, window, document, loadSentry, sentryOptions, adClient = null }) {
    let adScript = null;
    let adObserver = null;
    let sentryLoading = null;
    let reloadRequired = false;
    let adsRevoked = false;

    const canLoadAds = () => adClient && !adsRevoked && consent.validConsent() && consent.acceptedService('adsbygoogle', 'marketing');

    async function initializeAds() {
        if (!canLoadAds()) {
            return;
        }

        window.adsbygoogle = window.adsbygoogle || [];

        try {
            if (!adScript) {
                adScript = consent.loadScript(
                    `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(adClient)}`,
                    { async: '', crossorigin: 'anonymous' },
                );
            }

            const loaded = await adScript;

            if (!loaded) {
                console.warn('AdSense konnte nicht geladen werden.');
                return;
            }

            if (!canLoadAds()) {
                return;
            }

            const slots = document.querySelectorAll('ins.adsbygoogle:not([data-adsbygoogle-status]):not([data-ad-initialized])');

            for (const slot of slots) {
                if (!slot.isConnected || slot.hasAttribute('data-adsbygoogle-status') || slot.hasAttribute('data-ad-initialized') || slot.offsetWidth === 0) {
                    continue;
                }

                slot.setAttribute('data-ad-initialized', 'true');

                try {
                    window.adsbygoogle.push({});
                } catch (error) {
                    slot.removeAttribute('data-ad-initialized');
                    console.warn('AdSense-Anzeige konnte nicht initialisiert werden:', error);
                }
            }
        } catch (error) {
            console.warn('AdSense konnte nicht geladen werden:', error);
        }
    }

    function enableAds() {
        if (!canLoadAds()) {
            return;
        }

        if (!adObserver) {
            adObserver = new window.MutationObserver(() => initializeAds());
            adObserver.observe(document.body, { childList: true, subtree: true });
        }

        return initializeAds();
    }

    function enableSentry() {
        if (!sentryLoading) {
            sentryLoading = loadSentry().then(Sentry => {
                if (reloadRequired || !consent.acceptedService('sentry_io', 'analytics')) {
                    return;
                }

                Sentry.init({
                    ...sentryOptions,
                    integrations: [
                        Sentry.browserTracingIntegration(),
                        Sentry.replayIntegration(),
                    ],
                });
                window.Sentry = Sentry;
            }).catch(error => {
                sentryLoading = null;
                console.error('Sentry konnte nicht geladen werden:', error);
            });
        }

        return sentryLoading;
    }

    function rejectService() {
        reloadRequired = true;
    }

    function rejectAds() {
        adsRevoked = true;
        adObserver?.disconnect();

        if (window.adsbygoogle) {
            window.adsbygoogle.pauseAdRequests = 1;
        }

        rejectService();
    }

    return {
        enableAds,
        enableSentry,
        rejectService,
        rejectAds,
        requiresReload: () => reloadRequired,
    };
}
